const SIZE_MAP = {
  small: 25,
  medium: 35,
  large: 50
}

export default ({ fillColor = '#F6F6F6', strokeColor = '#DCDCDC', style = {}, size = 'large' }) => {
  const pixelSize = SIZE_MAP[size] || SIZE_MAP.large
  return (
    <svg
      width={pixelSize}
      height={pixelSize}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="25" cy="25" r="24" fill={fillColor} stroke={strokeColor} />
      <path d="M13 34H37" stroke={strokeColor} strokeWidth="2" />
      <circle cx="33.4" cy="17.8" r="2.4" fill={strokeColor} />
      <circle cx="16.5992" cy="17.8" r="2.4" fill={strokeColor} />
    </svg>
  )
}
